import Popup from './popup';
import $ from 'cash-dom';

let fmPopupId = 0;

/**
 * Caches content which was set first time.
 */
class PopupCacheable extends Popup {
	_initPopupProperties(config) {
		++fmPopupId;

		const $fmPopup = $(this._getPopupSelector());
		const $fmPopupClone = $fmPopup.clone();
		$fmPopupClone.attr('id', $fmPopupClone.attr('id') + '-' + fmPopupId);
		$fmPopup.after($fmPopupClone);

		this._$fmPopup = $fmPopupClone;
		this._$popupContent = this._$fmPopup.find(Popup.POPUP_CONTENT_SELECTOR);

		this.containerClass = config.containerClass;

		if (this.containerClass) {
			this._$popupContent.closest('.popup-container').addClass(this.containerClass);
		}
	}

	hide() {
		this._$fmPopup.hide();
		this._triggerPopupHide();
	}

	show(content = null, popupClass = null) {
		if (this._$popupContent.html()) {
			this._showPopupElement();
		} else {
			super.show(content, popupClass);
		}
	}

	resetCache() {
		this._$popupContent.html(null);
	}
}

export default PopupCacheable;
